import { createSlice } from "@reduxjs/toolkit";

const translationSlice = createSlice({
    name: 'translation',
    initialState: {
       language: 'en',
    },
   reducers : {
    switchLanguage: (state,{payload}) => {
      state.language =  payload
      }
    }
})

export const {
    switchLanguage,
} = translationSlice.actions

export default translationSlice.reducer
